import { Flair } from '@breakroom-nx/classes';
import { IMessage, User } from 'react-native-gifted-chat';

export interface IMessageUser extends User {
  geoCode: string;
}

export interface Translation {
  [languageCode: string]: string;
}

export class IMessageExt implements IMessage {
  _id: string | number;
  text: string;
  createdAt: Date | number;
  user: IMessageUser;
  image?: string;
  video?: string;
  audio?: string;
  system?: boolean;
  sent?: boolean;
  received?: boolean;
  pending?: boolean;
  quickReplies?: any;
  lang?: string;
  translations?: Translation;

  constructor(message: IMessage, user: IMessageUser) {
    this._id = message._id;
    this.text = message.text;
    this.createdAt = message.createdAt;
    this.user = user;
    this.image = message.image;
    this.video = message.video;
    this.audio = message.audio;
    this.system = message.system;
    this.sent = message.sent;
    this.received = message.received;
    this.pending = message.pending;
    this.quickReplies = message.quickReplies;
    this.lang = (message as any).lang;
    this.translations = (message as any).translations;
  }

  translate(languageCode: string): string | undefined {
    return this.translations?.[languageCode];
  }
}
